import Cookies from 'js-cookie';
import { call, put, takeLatest, all } from 'redux-saga/effects';

import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';

import { listShippingRates } from './api';
import {
  LIST_SHIPPING_REQUEST,
  SHIPPING_REQUESTING,
  LIST_SHIPPING_SUCCESS,
  RESET_SHIPPING_ISFETCHING
} from './constants';

export function* list() {
  try {
    yield call(removeAPIError);
    yield put({ type: SHIPPING_REQUESTING });
    const response = yield call(listShippingRates, cartId());
    yield put({ type: LIST_SHIPPING_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: RESET_SHIPPING_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* watchList() {
  yield takeLatest(LIST_SHIPPING_REQUEST, list);
}

export default function* shippingSagas() {
  yield all([watchList()]);
}
const cartId = () => Cookies.get('cartId');
